/**
 * Module activation contracts — mirrors `platform.module_activations`.
 *
 * Tracks which modules are enabled/disabled per tenant.
 */
import { z } from 'zod';

// ---------------------------------------------------------------------------
// Record (output)
// ---------------------------------------------------------------------------

export const ModuleActivationSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  moduleKey: z.string().min(1).max(100),
  isEnabled: z.boolean(),
  enabledAt: z.string().datetime({ offset: true }),
  disabledAt: z.string().datetime({ offset: true }).nullable(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
});
export type ModuleActivation = z.infer<typeof ModuleActivationSchema>;

// ---------------------------------------------------------------------------
// Toggle module input
// ---------------------------------------------------------------------------

export const ToggleModuleInputSchema = z.object({
  moduleKey: z.string().min(1).max(100),
  isEnabled: z.boolean(),
});
export type ToggleModuleInput = z.infer<typeof ToggleModuleInputSchema>;
